import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '@/views/Login'
// import Home from '@/views/Home'
import Home from '@/views/Home' //导航首页
import House from '@/views/House/index' //房产列表
import HouseAdd from '@/views/House/add' //房产新增
// import HouseDetail from '@/views/House/detail' //房产详情
import News from '@/components/News' //新闻
import Advertisemen from '@/views/Advertisemen/index'; //广告首页
import AdvertisemenAdd from '@/views/Advertisemen/add'; //广告添加
// import AdvertiseAddEdit from '@/views/Advertisemen/addEdit'; //广告修改
import Topic from '@/views/Topic/index'; //专题首页
import TopicAdd from '@/views/Topic/add'; //专题添加
import TopicDetail from '@/views/Topic/detailed'; //专题详情
import RelaNew from '@/views/Topic/relanew'; //专题关联新闻
import TopicEdit from '@/views/Topic/edit'; //专题修改
// import AddPub from '@/views/Topic/addPub'; //专题添加pub
// import EditPub from '@/views/Topic/editPub'; //专题添加pub
import MobileAdver from '@/views/Mobileadver/index'; //手机广告列表
import MobileAdd from '@/views/Mobileadver/add'; //手机广告添加列表
// import MobileDetail from '@/views/Mobileadver/detail'; //手机广告添加列表
import Audio from '@/views/Audio/index'; //音频的列表
import AudioAdd from '@/views/Audio/add'; //音频的添加
import AudioEdit from '@/views/Audio/edit'; //音频的添加
import ManagerIndex from '@/views/Manager/index'; //权限首页
import Video from '@/views/Video/index' //视频
import VideoAdd from '@/views/Video/add' //视频添加列表
import VideoEdit from '@/views/Video/videoEdit' //视频修改页
import Clock from '@/views/Clock/index'; //打卡列表----
// import ClockDetail from '@/views/Clock/detail'; //打卡详情----
import UserList from '@/views/User/list'; //用户管理
import RoleList from '@/views/Role/list'; //角色管理
import PageList from '@/views/Page/list'; //页面管理
import PermissionList from '@/views/Permission/list'; //权限管理
import UserPermission from '@/views/User/permission'; //用户权限
import Poor from '@/views/Poor/index'; //扶贫列表
import PoorDetail from '@/views/Poor/detail'; //扶贫详情
import Message from '@/views/Message'; //留言列表
import Vote from '@/views/Vote'; //投票列表
import VoteAdd from '@/views/Vote/voteAdd'; //投票添加
import Questionnaire from '@/views/Questionnaire/index'; //活动
import QuestionnaireAdd from '@/views/Questionnaire/add'; //添加活动
import CallUp from '@/views/Callup/index'; //召集令
import CallUpAdd from '@/views/Callup/add'; //召集令添加
import LongPic from '@/views/LongPic/index'; //长图广告
import LongPicAdd from '@/views/LongPic/add'; //长图广告添加
import Banner from '@/views/Banner/index'; //轮播图管理
import HouseInfo from '@/views/HouseInfo/index'; //楼盘信息
import HouseInfoAdd from '@/views/HouseInfo/add'; //添加楼盘信息
import FloorVideo from '@/views/FloorVideo/index'; //视频找房
import FloorVideoAdd from '@/views/FloorVideo/add'; //添加视频找房
import Salesman from '@/views/Salesman/index'; //置业经理
import SalesmanAdd from '@/views/Salesman/add'; //添加置业经理
import FloorSearch from '@/views/FloorSearch/index'; //房产查询
import OpenScreen from '@/views/OpenScreen/index'; //开屏广告
import OpenScreenAdd from '@/views/OpenScreen/add'; //开屏广告添加
import ShoppingMall from '@/views/ShoppingMall/index'; //商城
import AddGoods from '@/views/ShoppingMall/add'; //商城添加spu
import ShopList from '@/views/ShopList/index'; //商城轮播管理
import OrderList from '@/views/OrderList/index'; //订单列表
import Classification from '@/views/Classification/index'; //分类管理
import weChat from '@/index'; //聊天
import System from '@/views/System/index'; //系统配置
import broadCast from '@/views/broadCast/index'; //图文直播
import AddBroadCast from '@/views/broadCast/add'; //添加图文直播
import Lucky from '@/views/Lucky/index'; //抽奖
import AddAward from '@/views/Lucky/add'; //创建抽奖

import DynamicList from "@/views/Audit/DynamicList";//动态审核
import VideoList from "@/views/Audit/VideoList";//微观号视频审核
import NewsList from "@/views/Audit/NewsList";//微观号资讯审核
import TopicList from "@/views/Audit/TopicList";//话题审核
import Details from "@/views/Audit/Details"
import PreviewPage from "@/views/Audit/PreviewPage";
import TopicManageList from "@/views/Content/TopicManageList";//话题管理
import InformationManageList from "@/views/Content/InformationManageList";//微观号资讯管理
import MessageList from "@/views/Audit/MessageList";//留言审核
import ThematicManagementList from "@/views/Content/ThematicManagementList";//专题管理
import ThematicTagList from "@/views/Content/ThematicTagList";
import ThematicList from "@/views/Audit/ThematicList";
import OpenScreenList from "@/views/Ad/OpenScreenList";//开屏广告
import LongImageList from "@/views/Ad/LongImageList"; //长图广告
import PageImageList from "@/views/Ad/PageImageList"; //页面广告
import ReportAnnouncementList from "@/views/Content/ReportAnnouncementList";
import BanshouliList from "@/views/Banshouli/list"
import BanshouliAuditList from "@/views/Banshouli/auditList"
import BanshouliPreview from "@/views/Banshouli/banshouliPreview"
import VoteList from '@/views/Banshouli/voteList'
import VoteDetailsList from '@/views/Banshouli/voteDetailsList'
import VideoMamageList from '@/views/Content/VideoList' //视频管理
import VideoAuditList from '@/views/Audit/VideoManageList'
import ReportList from '@/views/Report/index'
import EduVoteList from '@/views/EducationVote/eduVoteList'  //教委投票~初始、晋级页面
import EliminateList from '@/views/EducationVote/failVoteList' //教委投票~淘汰页面

Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: 'Login',
    component: Login,
    meta: {
        requireAuth: true,

    },
},
    {
        path: '/home',
        name: 'Home',
        component: Home,

        children: [{
            // 房产列表
            path: '/house',
            name: 'House',
            component: House,
            meta: {
                requireAuth: true,
                roles: ['reviewer', 'publisher']
            },

        }, {
            // 房产列表新增
            path: '/houseAdd',
            name: 'HouseAdd',
            component: HouseAdd,
            meta: {
                requireAuth: true,
                roles: ['reviewer', 'publisher']
            },
        },
            // {
            //     // 房产列表详情
            //     path: '/houseDetail',
            //     name: 'HouseDetail',
            //     component: HouseDetail,
            //     meta: {
            //         requireAuth: true,
            //         roles: ['reviewer', 'publisher']
            //     },
            // },
            {
                path: '/news',
                name: 'News',
                component: News,
                meta: {
                    requireAuth: true,
                    roles: ['reviewer', 'publisher']
                },
            },
            {
                //广告首页
                path: '/advertisemen',
                name: 'Advertisemen',
                component: Advertisemen,
                meta: {
                    requireAuth: true,
                    roles: ['reviewer']
                },
            },

            {


                //广告新增
                path: '/advertisemenAdd',
                name: 'AdvertisemenAdd',
                component: AdvertisemenAdd,

            },
            // {
            //     //广告修改
            //     path: '/advertiseAddEdit/:edit',
            //     name: 'AdvertiseEdit',
            //     component: AdvertiseAddEdit,
            //     props: 'edit',
            //     meta: {
            //         requireAuth: true,
            //         roles: ['reviewer']
            //     },
            // },
            {
                //专题首页
                path: '/topic',
                name: 'Topic',
                component: Topic,

                meta: {
                    requireAuth: true,
                    roles: ['reviewer']
                },
            },
            {
                //专题添加
                path: '/topicAdd',
                name: 'TopicAdd',
                component: TopicAdd,

                meta: {
                    requireAuth: true,
                    roles: ['reviewer']
                },
            },
            {
                //专题详情
                path: '/topicDetail',
                name: 'TopicDetail',
                component: TopicDetail,
                meta: {
                    requireAuth: true,
                    roles: ['reviewer']
                },
            },
            {
                //专题关联新闻
                path: '/relaNew',
                name: 'RelaNew',
                component: RelaNew,
                meta: {
                    requireAuth: true,
                    roles: ['reviewer']
                },
            },
            {
                //专题修改
                path: '/topicEdit',
                name: 'TopicEdit',
                component: TopicEdit,
                meta: {
                    requireAuth: true,
                    roles: ['reviewer']
                },
            },
            // {
            //     //专题添加pub
            //     path: '/addPub',
            //     name: 'AddPub',
            //     component: AddPub,
            //     meta: {
            //         requireAuth: true,
            //         roles: ['reviewer']
            //     },
            // },
            // {
            //     //专题修改pub
            //     path: '/editPub',
            //     name: 'EditPub',
            //     component: EditPub,
            //     meta: {
            //         requireAuth: true,
            //         roles: ['reviewer']
            //     },
            // },
            {
                //手机广告列表
                path: '/mobileAdver',
                name: 'MobileAdver',
                component: MobileAdver,

                meta: {
                    requireAuth: true,
                    roles: ['reviewer']
                },
            },
            {
                //手机广告添加
                path: '/mobileAdd',
                name: 'MobileAdd',
                component: MobileAdd,

                meta: {
                    requireAuth: true,
                    roles: ['reviewer']
                },
            },

            // {
            //     //手机广告详情
            //     path: '/mobileDetail',
            //     name: 'MobileDetail',
            //     component: MobileDetail,
            //     props: { props: 'detail' },
            //     meta: {
            //         requireAuth: true,
            //         roles: ['reviewer']
            //     },
            // },
            // {
            //     //手机广告修改
            //     path: '/mobileEdit',
            //     name: 'MobileDetail',
            //     component: MobileDetail,
            //     props: { props: 'edit' },
            //     meta: {
            //         requireAuth: true,
            //         roles: ['reviewer']
            //     },
            // },

            {
                //音频列表
                path: '/audio',
                name: 'Audio',
                component: Audio,

                meta: {
                    requireAuth: true,
                    roles: ['reviewer']
                },
            },

            {
                //音频添加列表
                path: '/audioAdd',
                name: 'AudioAdd',
                component: AudioAdd,

                meta: {
                    requireAuth: true,
                    roles: ['reviewer']
                },
            },

            {
                //音频详情列表
                path: '/audioEdit',
                name: 'AudioEdit',
                component: AudioEdit,
                props: {prop: 'edit'},
                meta: {
                    requireAuth: true,
                    roles: ['reviewer']
                },
            },
            {
                //音频修改列表
                path: '/audioDetail',
                name: 'AudioEdit',
                component: AudioEdit,
                props: {prop: 'detail'},
                meta: {
                    requireAuth: true,
                    roles: ['reviewer']
                },
            },
            {
                //权限
                path: '/ManagerIndex',
                name: 'ManagerIndex',
                component: ManagerIndex,
                meta: {
                    requireAuth: true,
                    roles: ['admin']
                },
            },
            {
                //视频
                path: '/video',
                name: 'video',
                component: Video,
                // meta: {
                //     requireAuth: true,
                //     roles: ['admin']
                // },
            },
            {
                //视频
                path: '/videoAdd',
                name: 'videoAdd',
                component: VideoAdd,
            }, {
                // 视频修改页
                path: '/videoEdit',
                name: 'videoEdit',
                component: VideoEdit
            },
            {
                // 打卡列表
                path: '/clock',
                name: 'Clock',
                component: Clock
            },
            // {
            //     // 打卡详情
            //     path: '/clockDetail',
            //     name: 'ClockDetail',
            //     component: ClockDetail
            // },

            {
                //扶贫列表
                path: '/poor',
                name: 'Poor',
                component: Poor
            },
            {
                //扶贫详情
                path: '/poorDetail',
                name: 'PoorDetail',
                component: PoorDetail
            },
            {
                //用户管理
                path: '/userList',
                name: 'UserList',
                component: UserList
            },
            {
                //角色管理
                path: '/roleList',
                name: 'RoleList',
                component: RoleList
            },
            {
                //页面管理
                path: '/pageList',
                name: 'PageList',
                component: PageList
            },
            {
                //权限管理
                path: '/permissionList',
                name: 'PermissionList',
                component: PermissionList
            },
            {
              //动态审核
                path: '/dynamicList',
                name: 'DynamicList',
                component: DynamicList
            },
            {
                //微观号视频审核
                path: '/videoList',
                name: 'VideoList',
                component: VideoList
            },
            {
                //微观号资讯审核
                path: '/newsList',
                name: 'NewsList',
                component: NewsList
            },
            {
                //话题审核
                path: '/topicList',
                name: 'TopicList',
                component: TopicList
            },
            {
                path: '/details',
                name: 'Details',
                component: Details
            },
            {
                path: '/previewPage',
                name: 'PreviewPage',
                component: PreviewPage
            },
            {
                //用户权限
                path: '/userPermission',
                name: 'UserPermission',
                component: UserPermission
            },
            {
                //留言列表
                path: '/message',
                name: 'Message',
                component: Message
            },
            {
                //投票
                path: '/vote',
                name: 'Vote',
                component: Vote
            },
            {
                // 投票添加
                path: '/voteAdd',
                name: 'VoteAdd',
                component: VoteAdd
            },
            {
                // 问卷调查
                path: '/wj',
                name: 'Questionnaire',
                component: Questionnaire
            },
            {
                // 问卷调查
                path: '/wjAdd',
                name: 'QuestionnaireAdd',
                component: QuestionnaireAdd
            },
            {
                // 召集令
                path: '/callUp',
                name: 'CallUp',
                component: CallUp
            },
            {
                // 召集令
                path: '/callUpAdd',
                name: 'CallUpAdd',
                component: CallUpAdd
            },
            {
                // 长图广告
                path: '/longPic',
                name: 'LongPic',
                component: LongPic
            },
            {
                // 长图广告
                path: '/longPicAdd',
                name: 'LongPicAdd',
                component: LongPicAdd
            },
            {
                // 轮播管理
                path: '/banner',
                name: 'Banner',
                component: Banner
            },
            {
                // 楼盘信息
                path: '/houseInfo',
                name: 'HouseInfo',
                component: HouseInfo
            },
            {
                // 楼盘信息
                path: '/houseInfoAdd',
                name: 'HouseInfoAdd',
                component: HouseInfoAdd
            },
            {
                // 视频找房
                path: '/floorVideo',
                name: 'FloorVideo',
                component: FloorVideo
            },
            {
                // 添加视频找房
                path: '/floorVideoAdd',
                name: 'FloorVideoAdd',
                component: FloorVideoAdd
            },
            {
                // 置业经理
                path: '/salesman',
                name: 'Salesman',
                component: Salesman
            },
            {
                path: '/salesmanAdd',
                name: 'SalesmanAdd',
                component: SalesmanAdd
            },
            {
                path: '/floorSearch',
                name: 'FloorSearch',
                component: FloorSearch
            },
            {
                path: '/openScreen',
                name: 'OpenScreen',
                component: OpenScreen
            },
            {
                path: '/openScreenAdd',
                name: "OpenScreenAdd",
                component: OpenScreenAdd
            },
            {
                path: "/shoppingMall",
                name: "ShoppingMall",
                component: ShoppingMall
            },
            {
                path: "/addGoods",
                component: AddGoods
            },
            {
                path: "/shopList",
                component: ShopList
            },
            {
                path: "/orderList",
                component: OrderList
            },
            {
                path: "/scType",
                component: Classification
            },
            {
                path: "/weChat",
                component: weChat
            },
            {
                path: "/system",
                component: System
            },
            {
                path: "/broadcast",
                component: broadCast
            },
            {
                path: "/addBroadCast",
                component: AddBroadCast
            },
            {
                path: "/lucky",
                component: Lucky
            },
            {
                path: "/addAward",
                component: AddAward
            },
            {
                //话题管理
                path: '/topicManageList',
                name: 'TopicManageList',
                component: TopicManageList
            },
            {
                //微观号资讯管理
                path: '/informationManageList',
                name: 'InformationManageList',
                component: InformationManageList
            },
            {
                //留言审核
                path: '/messageList',
                name: 'MessageList',
                component: MessageList
            },
            {
                //专题管理
                path: '/thematicManagementList',
                name: 'ThematicManagementList',
                component: ThematicManagementList
            },
            {
                //专题管理标签
                path: '/thematicTagList',
                name: 'ThematicTagList',
                component: ThematicTagList
            },
            {
                //专题审核
                path: '/thematicList',
                name: 'ThematicList',
                component: ThematicList
            },
            {
                //开屏广告
                path: '/openScreenList',
                name: 'OpenScreenList',
                component: OpenScreenList
            },
            {
                //长图广告
                path: '/longImageList',
                name: 'LongImageList',
                component: LongImageList
            },
            {
                //页面广告
                path: '/pageImageList',
                name: 'PageImageList',
                component: PageImageList
            },
            {
                //举报公告
                path: '/reportAnnouncementList',
                name: 'ReportAnnouncementList',
                component: ReportAnnouncementList
            },
            {
                //伴手礼
                path: '/banshouliList',
                name: 'BanshouliList',
                component: BanshouliList
            },
            {
                //伴手礼审核
                path: '/banshouliAuditList',
                name: 'BanshouliAuditList',
                component: BanshouliAuditList
            },
            {
                //伴手礼预览
                path: '/banshouliPreview',
                name: 'BanshouliPreview',
                component: BanshouliPreview
            },
            {
                //伴手礼投票
                path: '/voteList',
                name: 'VoteList',
                component: VoteList
            },
            {
                //伴手礼投票
                path: '/voteDetailsList',
                name: 'VoteDetailsList',
                component: VoteDetailsList
            },
            {
                //视频管理
                path: '/videoManageList',
                name: 'VideoMamageList',
                component: VideoMamageList
            },
            {
                //视频审核管理
                path: '/videoAuditList',
                name: 'VideoAuditList',
                component: VideoAuditList
            },
            {
                //举报管理
                path: '/reportList',
                name: 'ReportList',
                component: ReportList
            },
            {
                //教委投票管理
                path: '/eduVoteList',
                name: 'EduVoteList',
                component: EduVoteList
            },
             {
                //淘汰列表
                path: '/eliminateList',
                name: 'EliminateList',
                component: EliminateList
            }
        ],

    },

]

const router = new VueRouter({
    // mode: 'history',
    routes,
    linkActiveClass: 'active'
})
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
export default router
